import type { Server } from 'miragejs';

export function getUser(this: Server) {
  return this.get('users');
}
